export default "__VITE_ASSET__3fef77cc__"